import React from "react";
import { Typography } from "@mui/material";
import styled from "styled-components";
import { ResultsResponse } from "lib-core";

const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 280px;
  background: ${({ theme }) => theme.palette.brandGray.light};
  padding: 20px;
`;
const TitleBox = styled.div`
  width: 100%;
`;
const TextContainer = styled.div`
  width: 100%;
`;

interface RecordingProgressProps {
  results: ResultsResponse;
}

const RecordingProgress: (props: RecordingProgressProps) => JSX.Element = ({
  results,
}) => {
  const testCompletionRate = results?.testCompletionRate ?? 0;
  const parsedTestCompletionRate = parseFloat(
    (testCompletionRate * 100).toFixed(0)
  );

  const coverageRates = Object.values(results.testCoverageRate).flatMap(
    (coverageRate) => Object.values(coverageRate)
  );

  const minCoverageRate =
    coverageRates.length === 0 ? 0 : Math.min(...coverageRates);
  const maxCoverageRate =
    coverageRates.length === 0 ? 0 : Math.max(...coverageRates);

  const parsedMinCoverageRate = parseFloat((minCoverageRate * 100).toFixed(2));
  const parsedMaxCoverageRate = parseFloat((maxCoverageRate * 100).toFixed(2));

  return (
    <Container>
      <TitleBox>
        <Typography variant="h4">Recording Progress</Typography>
      </TitleBox>
      <TextContainer>
        <Typography variant="body1">
          {`Completion rate ${parsedTestCompletionRate}%`}
        </Typography>
        <Typography variant="body1">
          {`Coverage rate min ${parsedMinCoverageRate}%`}
        </Typography>
        <Typography variant="body1">
          {`Coverage rate max ${parsedMaxCoverageRate}%`}
        </Typography>
      </TextContainer>
    </Container>
  );
};

export default RecordingProgress;
